module.exports = __webpack_public_path__ + "img/Loyalty-ability-02.6e409141.png";